'use strict';

const isPressing = new WeakSet();

exports.isPressing = isPressing;
//# sourceMappingURL=state.cjs.map
